var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};

// db/WebmFile.ts
import { onlyClient } from "@adornis/base/decorators/onlyClient.js";
import { BaseQLClient } from "@adornis/baseql/client/baseqlClient.js";
import { StreamableFile } from "@adornis/file-utils/db/streamables.js";
import { fileConfig } from "@adornis/file-utils/config.js";
import { join } from "node:path";
import { unlink, writeFile } from "node:fs/promises";
import { spawn } from "node:child_process";
import { logger } from "@adornis/base/logging.js";
import { Entity } from "@adornis/baseql/decorators.js";
var WebmFile = class extends StreamableFile {
  static async customUploadHandler(additionalInfo, retrievedFiles, fileID) {
    const { recordingID } = additionalInfo;
    if (!recordingID)
      throw new Error("no recordingID given");
    const filePaths = Object.entries(retrievedFiles).map(([key, file]) => {
      if (Array.isArray(file))
        throw new Error("cannot upload multiple files with the same name");
      return file.tempFilePath;
    });
    const outPath = join(fileConfig.get("tempDatadir"), `${recordingID}.webm`);
    const inputsFile = join(fileConfig.get("tempDatadir"), `${recordingID}_inputs.txt`);
    await writeFile(inputsFile, filePaths.map((p) => `file '${p}'`).join("\n"));
    const err = await new Promise((resolve) => {
      let stdout = "";
      let stderr = "";
      const ffmpeg = spawn("ffmpeg", ["-y", "-safe", "0", "-f", "concat", "-i", inputsFile, "-c", "copy", outPath]);
      ffmpeg.stdout.on("data", (data) => stdout += data);
      ffmpeg.stderr.on("data", (data) => stderr += data);
      ffmpeg.on("close", (code) => {
        logger.debug({ stdout, stderr, code }, "ffmpeg output");
        if (code !== 0)
          resolve(new Error("ffmpeg exited with non-zero exit code:\nStdout: " + stdout + "\nStderr: " + stderr));
        else
          resolve();
      });
      ffmpeg.on("error", (error) => {
        resolve(error);
      });
    });
    if (err)
      logger.error({ err }, "error while transcoding webm");
    for (const path of filePaths.concat([inputsFile])) {
      await unlink(path).catch((e) => {
        if (e.code === "ENOENT")
          return;
        logger.warn(e, "error while cleaning up tmpPath of WebmFile part");
      });
    }
    return this.createFromPath(outPath, additionalInfo);
  }
  static async upload(file, { acceptFileTypes, additionalInfo = {} } = {}) {
    throw new Error("Please use WebmFile.uploadParts instead of WebmFile.upload");
    return "";
  }
  static async uploadParts(recordingID, files, { acceptFileTypes, additionalInfo = {} } = {}) {
    const formData = new FormData();
    let index = 0;
    for (const file of files)
      formData.append("" + index++, file);
    formData.append(
      "_file_additional_info",
      JSON.stringify({ ...additionalInfo, sessionID: BaseQLClient.sessionID, recordingID })
    );
    return this._uploadFormData(formData);
  }
};
WebmFile._class = "WebmFile";
WebmFile.customUpload = true;
__decorateClass([
  onlyClient
], WebmFile, "upload", 1);
__decorateClass([
  onlyClient
], WebmFile, "uploadParts", 1);
WebmFile = __decorateClass([
  Entity()
], WebmFile);
export {
  WebmFile
};
